import * as S from './styles';
import { ClientProps } from '@/types';
import { useUserContext } from '@/hooks';
import { OrderItemsProps } from '@/talons/orderStatusPage/useOrderStatusPage';
import {
  RiUserStarLine,
  RiUser3Line,
  RiMapPin2Line,
  RiFileTextLine,
  RiFileListLine,
  RiTruckLine,
  RiCheckboxCircleLine,
  RiBarcodeBoxLine,
  RiMoneyDollarBoxLine,
} from 'react-icons/ri';
import paymentTypes from '@/shared/payments';
import { formatCurrency } from '@/shared';

interface Props {
  client: ClientProps;
  order: OrderItemsProps;
}

const SharedOrderHeader = ({ order, client }: Props) => {
  const { customer } = useUserContext();
  return (
    <S.OrderHeader>
      <S.RowGrid grids={3}>
        <S.Row>
          <S.BgIcon>
            <RiUserStarLine color='#fff' size={12} />
          </S.BgIcon>

          <S.Col>
            <S.Text>Representante comercial:</S.Text>
            <S.BoldText position='flex-start'>
              {customer?.firstname} {customer?.lastname}
            </S.BoldText>
          </S.Col>
        </S.Row>

        <S.Row>
          <S.BgIcon>
            <RiUser3Line color='#fff' size={12} />
          </S.BgIcon>
          <S.Text>{client?.NM_CLIENTE}</S.Text>
        </S.Row>

        <S.Row>
          <S.BgIcon>
            <RiMapPin2Line color='#fff' size={12} />
          </S.BgIcon>
          <S.Text>{`${client?.ENDERECO}, ${client?.NUMERO} - ${client?.BAIRRO}, ${client?.CIDADE} - ${client?.ESTADO}, ${client?.CEP}`}</S.Text>
        </S.Row>
      </S.RowGrid>

      <S.Line />

      <S.RowFlex>
        <S.Row style={{ alignItems: 'center' }}>
          <RiFileTextLine size={22} />

          <S.Col>
            <S.Text style={{ color: '#828282', whiteSpace: 'nowrap' }}>Nº do pedido:</S.Text>
            <S.BoldText>{order.orderNumber}</S.BoldText>
          </S.Col>
        </S.Row>

        <S.Row style={{ alignItems: 'center' }}>
          <RiFileListLine size={22} />

          <S.Col>
            <S.Text style={{ color: '#828282', whiteSpace: 'nowrap' }}>Nº ERP:</S.Text>
            <S.BoldText>{order.erpNumber || '-'}</S.BoldText>
          </S.Col>
        </S.Row>

        <S.Row style={{ alignItems: 'center' }}>
          <RiTruckLine size={22} />

          <S.Col>
            <S.Text style={{ color: '#828282', whiteSpace: 'nowrap' }}>Qtd. itens:</S.Text>
            <S.BoldText>
              {order.quantity} {order.quantity === 1 ? 'item' : 'itens'}
            </S.BoldText>
          </S.Col>
        </S.Row>

        <S.Row style={{ alignItems: 'center', maxWidth: '180px' }}>
          <RiBarcodeBoxLine size={22} />

          <S.Col>
            <S.Text style={{ color: '#828282', whiteSpace: 'nowrap' }}>Pagamento via:</S.Text>
            <S.BoldText>{paymentTypes[order.paymentTerms as keyof typeof paymentTypes].label}</S.BoldText>
          </S.Col>
        </S.Row>

        <S.Row style={{ alignItems: 'center' }}>
          <RiMoneyDollarBoxLine size={22} />

          <S.Col>
            <S.Text style={{ color: '#828282', whiteSpace: 'nowrap', justifyContent: 'flex-end'}}>Total final:</S.Text>
            <S.BoldText style={{ color: '#27AE61', fontSize: '11px', justifyContent: 'flex-end' }}>
              {formatCurrency({ value: order.total, isFormat: true })}
            </S.BoldText>
          </S.Col>
        </S.Row>
      </S.RowFlex>

      <S.Line />

      <S.RowFlex style={{ justifyContent: 'center', gap: '70px', position: 'relative' }}>
        <S.Col style={{ alignItems: 'center', gap: '5px', justifyContent: 'center' }}>
          <RiCheckboxCircleLine color='#27AE61' size={16} />

          <S.CheckStep $checked>
            {/* <S.LineProgress $checked /> */}
          </S.CheckStep>

          <S.BoldText style={{ color: '#27AE61', justifyContent: 'center', width: '100%' }}>
            Pedido recebido
          </S.BoldText>
          
          <S.Text style={{ justifyContent: 'center', width: '100%', color: '#999999' }}>
            {order.orderDate}
          </S.Text>
        </S.Col>

        <S.Col style={{ alignItems: 'center', gap: '5px', justifyContent: 'center' }}>
          <RiFileTextLine color='#999999' size={16} />

          <S.CheckStep />

          <S.BoldText style={{ justifyContent: 'center', width: '100%' }}>
            Status do pedido
          </S.BoldText>

          <S.Text style={{ justifyContent: 'center', width: '100%', color: '#999999' }}>
            {order.status}
          </S.Text>
        </S.Col>
      </S.RowFlex>
    </S.OrderHeader>
  );
};

export default SharedOrderHeader;
